import { Component } from "react";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

// icons
import OpenChevron from "@material-ui/icons/PlayArrow";
import PropTypes from "prop-types";

// helpers

// styles
import "./Home.scss";

let background = "#f9f9f9";
if (import.meta.env.MODE === "production") {
  background = "#bdb76b";
}

export const activeStyle = {
  borderLeft: "#ff9300 4px solid",
  display: "block",
  background,
};

export default class RetractableSidebar extends Component {
  constructor(props) {
    super(props);
    var obj = this.getStorageObject();

    // get the previous state
    // if not set use the one form props
    // and detault to true

    if (obj.open === false || obj.open === true) {
      this.state = {
        open: obj.open,
      };
    } else {
      this.state = {
        open: props.open === false ? false : true,
      };

      this.setStorageObject({ open: this.state.open });
    }
  }

  getStorageName = () => {
    return "sidebar_" + this.props.storageKey;
  };

  getStorageObject = () => {
    let objectName = this.getStorageName();
    var retrievedObject = localStorage.getItem(objectName);
    if (!retrievedObject) {
      return {};
    }
    return JSON.parse(retrievedObject);
  };

  setStorageObject = (setObject) => {
    let objectName = this.getStorageName();
    localStorage.setItem(objectName, JSON.stringify(setObject));
  };

  render() {
    let chevronStyles = this.getChewronStyles();
    let wrapperStyle = this.getWrapperStyles();

    return (
      <div style={wrapperStyle}>
        <List>
          <ListItem onClick={this.changeOpenState}>
            <ListItemIcon>
              <OpenChevron style={chevronStyles} />
            </ListItemIcon>
            <ListItemText primary="Hide" />
          </ListItem>
          <Divider />
        </List>
        <List>{this.props.children}</List>
      </div>
    );
  }
  ////

  changeOpenState = () => {
    let toSet = !this.state.open;
    this.setState({ ...this.state, open: toSet });
    this.setStorageObject({ open: toSet });
  };

  ////
  getChewronStyles = () => {
    let style = {};
    style.transform = this.state.open ? "rotate(-90deg)" : "rotate(0deg)";
    style.WebkitTransform = this.state.open ? "rotate(-90deg)" : "rotate(0deg)";
    return style;
  };

  getWrapperStyles = () => {
    let backgroundColor = "#55ab96";

    if (import.meta.env.MODE === "production") {
      backgroundColor = "#f3e5b2";
    }

    let style = {};
    style.transition = "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms";
    style.width = this.state.open ? "220px" : "60px";
    style.overflow = "hidden";
    style.flex = "0 0 auto";
    style.boxShadow =
      "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px";
    style.backgroundColor = backgroundColor;
    style.zIndex = this.props.zIndex ? this.props.zIndex : "10";
    return style;
  };
}

RetractableSidebar.propTypes = {
  children: PropTypes.any,
  open: PropTypes.bool,
  storageKey: PropTypes.string.isRequired,
};
